var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require("@/assets/icons/loading.svg"),"alt":"loading"}}),(_vm.waiting)?_c('span',[_vm._v("If this doesn't load within a few seconds please refresh :)")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }